import { useI18n } from "../i18n/useI18n";

export function LanguageSwitcher() {
  const { locale, setLocale, t } = useI18n();

  return (
    <div className="seg" role="group" aria-label={t("lang.aria")}>
      {(["uk", "en", "es"] as const).map((code) => (
        <button
          key={code}
          type="button"
          className={"seg__btn" + (locale === code ? " seg__btn--on" : "")}
          onClick={() => setLocale(code)}
          aria-pressed={locale === code}
        >
          {code === "uk"
            ? t("lang.switch.uk")
            : code === "en"
              ? t("lang.switch.en")
              : t("lang.switch.es")}
        </button>
      ))}
    </div>
  );
}
